// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._comparisonHeader_u9d4d_1 {
  --pa-comparison-header-border-width-inner: var(--pa-comparison-header-border-width, 0);
  --perxis-auto-header-border-width: var(--pa-comparison-header-border-width-inner);
  --perxis-auto-header-padding: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
